import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { findRaw as findChosenPackage } from "@Api/Admin/instantDealsWon";
import { find as findCustomerUser } from "@Api/Customers/users";
import { find as findSupplier } from "@Api/Suppliers/companies";
import HoverTooltip from "@Components/HoverTooltip";
import LoadingFallback from "@Components/Pages/Fallbacks/Loading";
import NotFoundFallback from "@Components/Pages/Fallbacks/NotFound";
import { INSTANT_DEALS_WON } from "@Shared/Paths/Admin";
import { isNetworkId, networkNames, renderNetworkIcon, } from "../../../../Supplier/Pages/PredictInstant/AmendTariffs/networkConfig";
import { ArrowNarrowLeft, Building04, File02, InfoCircle, User01, } from "../../../../Supplier/Pages/PredictInstant/components/icons";
import iconStyles from "../../../../Supplier/Pages/PredictInstant/components/icons/index.module.scss";
import { formatSubmittedDate, formatSubmittedDateTime, } from "../../../../Supplier/Pages/PredictInstant/DealsWon/chosenPackageHelpers";
import { mapChosenPackageToDealDetail } from "../../../../Supplier/Pages/PredictInstant/DealsWon/mapChosenPackageToDealDetail";
import StatusBadge from "../../../../Supplier/Pages/PredictInstant/DealsWon/StatusBadge";
import styles from "./index.module.scss";
const DetailRowItem = ({ label, value, valueTone = "default", }) => (React.createElement("div", { className: styles.detailRow },
    React.createElement("span", { className: styles.detailLabel }, label),
    React.createElement("span", { className: `${styles.detailValue} ${valueTone === "green"
            ? styles.detailValueGreen
            : valueTone === "muted"
                ? styles.detailValueMuted
                : ""}` }, value)));
const CUSTOMER_SERVICE_TOOLTIP = "All suppliers meet a high service standard–traffic lights show relative performance.";
const StatColumn = ({ items, }) => (React.createElement("div", { className: styles.statColumn }, items.map((item, index) => (React.createElement(React.Fragment, { key: item.label },
    index > 0 && React.createElement("div", { className: styles.divider }),
    React.createElement(DetailRowItem, { label: item.label, value: item.value }))))));
const DealSummaryCard = ({ deal }) => (React.createElement("div", { className: styles.dealCard },
    React.createElement("div", { className: styles.dealCardInner },
        React.createElement("div", { className: styles.networkHeader },
            React.createElement("div", { className: styles.networkLogoWrap }, isNetworkId(deal.networkId) &&
                renderNetworkIcon(deal.networkId, styles.networkLogo)),
            React.createElement("div", { className: styles.networkMeta },
                React.createElement("h2", { className: styles.networkName }, networkNames[deal.networkId]),
                React.createElement("p", { className: styles.networkSubtitle },
                    React.createElement("strong", null, deal.contractMonths),
                    " Month Contract \u00B7",
                    " ",
                    React.createElement("strong", null, deal.lines),
                    " Lines",
                    " "))),
        React.createElement("div", { className: styles.dealBody },
            React.createElement("div", { className: styles.totalCostBanner },
                React.createElement("p", { className: styles.totalCostLabel },
                    "Total Contract Cost (",
                    deal.contractMonths,
                    " Months)"),
                React.createElement("p", { className: styles.totalCostValue }, deal.totalContractCost)),
            React.createElement("div", { className: styles.costPanel },
                React.createElement("div", { className: styles.costItems }, deal.costBreakdown.lineItems.map((item) => (React.createElement("div", { key: `${item.label}-${item.rateLabel}`, className: styles.costItem },
                    React.createElement("span", { className: styles.countBadge }, item.count),
                    React.createElement("span", { className: styles.costItemLabel },
                        React.createElement("strong", null, item.label),
                        " ",
                        item.rateLabel),
                    React.createElement("span", { className: styles.costItemValue }, item.total))))),
                React.createElement("div", { className: styles.costTotals },
                    React.createElement("div", { className: styles.divider }),
                    React.createElement(DetailRowItem, { label: React.createElement("strong", { style: { fontWeight: 600 } }, "Total per Month"), value: deal.costBreakdown.totalPerMonth, valueTone: "green" }),
                    React.createElement(DetailRowItem, { label: React.createElement("strong", { style: { fontWeight: 600 } },
                            "Total for ",
                            deal.contractMonths,
                            " Months"), value: deal.costBreakdown.totalForContract, valueTone: "green" }),
                    React.createElement(DetailRowItem, { label: "Total Incl. Phones", value: deal.costBreakdown.totalInclPhones, valueTone: "muted" })))),
        React.createElement("div", { className: styles.quickStats },
            React.createElement(StatColumn, { items: [
                    { label: "Lines", value: deal.quickStats.lines },
                    { label: "Calls", value: deal.quickStats.calls },
                    { label: "Texts", value: deal.quickStats.texts },
                ] }),
            React.createElement(StatColumn, { items: [
                    { label: "Phones", value: deal.quickStats.phones },
                    {
                        label: "Contract",
                        value: deal.quickStats.contract,
                    },
                ] })),
        React.createElement("div", { className: styles.sectionHeading },
            React.createElement(File02, { className: `${iconStyles.icon} ${iconStyles.file02}` }),
            React.createElement("span", null, "Tariff Detail")),
        React.createElement("div", { className: styles.tariffPanel },
            React.createElement("div", { className: styles.tariffPanelBox },
                deal.ukCharges.length > 0 && (React.createElement("div", { className: styles.chargeGroup },
                    React.createElement("p", { className: styles.chargeGroupTitle }, "UK Charges:"),
                    React.createElement("div", { className: styles.tariffTitleDivider }),
                    deal.ukCharges.map((row, index) => (React.createElement(React.Fragment, { key: row.label },
                        React.createElement(DetailRowItem, { ...row, valueTone: "muted" }),
                        index < deal.ukCharges.length - 1 && (React.createElement("div", { className: styles.divider }))))))),
                deal.roamingCharges.length > 0 && (React.createElement("div", { className: styles.chargeGroup },
                    React.createElement("p", { className: styles.chargeGroupTitle }, "Roaming Charges:"),
                    React.createElement("div", { className: styles.tariffTitleDivider }),
                    deal.roamingCharges.map((row, index) => (React.createElement(React.Fragment, { key: row.label },
                        React.createElement(DetailRowItem, { ...row, valueTone: "muted" }),
                        index < deal.roamingCharges.length - 1 && (React.createElement("div", { className: styles.divider }))))))))),
        React.createElement("div", { className: styles.additionalServices },
            React.createElement("div", { className: styles.serviceRow },
                React.createElement("div", { className: styles.serviceLabelWrap },
                    React.createElement("span", null, "Customer Service"),
                    React.createElement(HoverTooltip, { icon: React.createElement("button", { type: "button", className: styles.infoButton, "aria-label": CUSTOMER_SERVICE_TOOLTIP },
                            React.createElement(InfoCircle, { className: `${iconStyles.icon} ${iconStyles.infoCircle}` })) }, CUSTOMER_SERVICE_TOOLTIP)),
                React.createElement("div", { className: styles.serviceBadges }, deal.additionalServices.customerServiceBadges.map((badge) => (React.createElement("span", { key: badge.label, className: badge.tone === "good"
                        ? styles.greenBadge
                        : badge.tone === "medium"
                            ? styles.amberBadge
                            : styles.redBadge }, badge.label))))),
            React.createElement("div", { className: styles.divider }),
            React.createElement("div", { className: styles.serviceInlineRow },
                React.createElement("span", null, "Roaming Type"),
                React.createElement("span", { className: styles.grayBadge }, deal.additionalServices.roamingType)),
            React.createElement("div", { className: styles.divider }),
            React.createElement("div", { className: styles.serviceInlineRow },
                React.createElement("span", null, "Phones"),
                React.createElement("span", { className: styles.grayBadge }, deal.additionalServices.phones)),
            React.createElement("div", { className: styles.divider }),
            React.createElement("div", { className: styles.serviceInlineRow },
                React.createElement("span", null, "SIM Change"),
                React.createElement("span", { className: styles.grayBadge }, deal.additionalServices.simChange))))));
const CustomerInfoCard = ({ deal }) => (React.createElement("div", { className: styles.infoCard },
    React.createElement("div", { className: styles.infoCardHeader },
        React.createElement("div", { className: styles.customerIconWrap },
            React.createElement(User01, { className: `${iconStyles.icon} ${iconStyles.user01}` })),
        React.createElement("h2", { className: styles.infoCardTitle }, "Customer Information")),
    React.createElement("div", { className: styles.infoRows },
        React.createElement(DetailRowItem, { label: "Customer", value: deal.customerName }),
        React.createElement("div", { className: styles.divider }),
        React.createElement(DetailRowItem, { label: "Email", value: deal.customerEmail || "—", valueTone: deal.customerEmail ? "green" : "default" }),
        React.createElement("div", { className: styles.divider }),
        React.createElement(DetailRowItem, { label: "Phone", value: deal.phone, valueTone: deal.phone === "—" ? "default" : "green" }),
        React.createElement("div", { className: styles.divider }),
        React.createElement("div", { className: styles.detailRow },
            React.createElement("span", { className: styles.detailLabel }, "Registered Company"),
            React.createElement("span", { className: styles.grayBadge }, deal.registeredCompany ? "Yes" : "No")),
        React.createElement("div", { className: styles.divider }),
        React.createElement(DetailRowItem, { label: "Company Number", value: deal.companyNumber }),
        React.createElement("div", { className: styles.divider }),
        React.createElement(DetailRowItem, { label: "Submitted At", value: formatSubmittedDateTime(deal.submittedAt) }))));
const SupplierInfoCard = ({ deal }) => (React.createElement("div", { className: styles.infoCard },
    React.createElement("div", { className: styles.infoCardHeader },
        React.createElement("div", { className: styles.supplierIconWrap },
            React.createElement(Building04, { className: `${iconStyles.icon} ${iconStyles.building04}` })),
        React.createElement("h2", { className: styles.infoCardTitle }, "Supplier Information")),
    React.createElement("div", { className: styles.infoRows },
        React.createElement(DetailRowItem, { label: "Company Number", value: deal.supplierCompanyNumber || "—" }),
        React.createElement("div", { className: styles.divider }),
        React.createElement(DetailRowItem, { label: "Company Name", value: deal.supplierName || "—" }))));
const DealDetail = () => {
    const history = useHistory();
    const { packageId = "" } = useParams();
    const [deal, setDeal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    useEffect(() => {
        let cancelled = false;
        const loadDeal = async () => {
            setLoading(true);
            setNotFound(false);
            try {
                const raw = await findChosenPackage(packageId);
                if (cancelled)
                    return;
                const customerId = typeof raw.customerId === "string" ? raw.customerId : "";
                const customerUserId = typeof raw.customerUserId === "string"
                    ? raw.customerUserId
                    : "";
                const supplierId = typeof raw.supplierId === "string" ? raw.supplierId : "";
                const [customerUserResult, supplierResult] = await Promise.allSettled([
                    customerId && customerUserId
                        ? findCustomerUser(customerId, customerUserId)
                        : Promise.reject(),
                    supplierId
                        ? findSupplier(supplierId)
                        : Promise.reject(),
                ]);
                const enrichedRaw = customerUserResult.status === "fulfilled"
                    ? {
                        ...raw,
                        customerUser: {
                            name: customerUserResult.value.name,
                            email: customerUserResult.value.email,
                            mobileNumber: customerUserResult.value.mobileNumber,
                        },
                    }
                    : raw;
                const mapped = mapChosenPackageToDealDetail(enrichedRaw);
                if (!mapped) {
                    setNotFound(true);
                    setDeal(null);
                    return;
                }
                const supplier = supplierResult.status === "fulfilled"
                    ? supplierResult.value
                    : null;
                setDeal({
                    ...mapped,
                    supplierName: supplier?.name ?? "—",
                    supplierCompanyNumber: supplier?.companyNo ?? "—",
                });
            }
            catch (error) {
                console.error("Failed to load deal detail", error);
                if (!cancelled) {
                    setNotFound(true);
                    setDeal(null);
                }
            }
            finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        loadDeal();
        return () => {
            cancelled = true;
        };
    }, [packageId]);
    if (loading)
        return React.createElement(LoadingFallback, null);
    if (notFound || !deal)
        return React.createElement(NotFoundFallback, null);
    return (React.createElement("div", { className: styles.page },
        React.createElement("div", { className: styles.body },
            React.createElement("div", { className: styles.pageHeader },
                React.createElement("button", { type: "button", className: styles.backButton, onClick: () => history.push(INSTANT_DEALS_WON), "aria-label": "Back to Instant Deals Won" },
                    React.createElement(ArrowNarrowLeft, { className: `${iconStyles.icon} ${iconStyles.arrowNarrowLeft}` })),
                React.createElement("h1", { className: styles.title }, deal.customerName),
                React.createElement("span", { className: styles.submittedBadge },
                    "Submitted ",
                    formatSubmittedDate(deal.submittedAt)),
                React.createElement(StatusBadge, { status: deal.status })),
            React.createElement("div", { className: styles.contentGrid },
                React.createElement(DealSummaryCard, { deal: deal }),
                React.createElement("div", { className: styles.rightColumn },
                    React.createElement(CustomerInfoCard, { deal: deal }),
                    React.createElement(SupplierInfoCard, { deal: deal }))))));
};
export default DealDetail;
